import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
})
export class AboutUsComponent {
  aboutUs = {
    years: 4,
    title: 'About Us',
    description:
      'We offer unlimited, high-speed fiber optic broadband to the rural/semi-rural homes in Western Loudoun County, VA.',
    features: [
      {
        icon: '/images/about/1.svg',
        description:
          'We are a passionate small business that is bringing High Speed Fiber Optic Broadband to areas others won’t even try!',
      },
      {
        icon: '/images/about/2.svg',
        description:
          'Our team is installing our own fiber cables to provide internet access to mostly rural homes.',
      },
      {
        icon: '/images/about/1.svg',
        description:
          'We also offer customized broadband solutions and a premier Voice and Video service to replace outdated Verizon copper phone lines.',
      },
      {
        icon: '/images/about/2.svg',
        description:
          'We truly believe that we are providing a vital service to rural homes that have been overlooked for too long!',
      },
    ],
    images: [
      '/images/about/1.png',
      '/images/about/2.png',
      '/images/about/3.png',
      '/images/about/4.png',
      '/images/about/5.png',
      '/images/about/1.svg',
      '/images/about/2.svg',
    ],
  };
}
